export class LocalDatabaseError extends Error {
    constructor(message, options) {
        super(message, options);
        this.name = new.target.name;
    }
}
export class ProfileAccessDeniedError extends LocalDatabaseError {
    required_action;
    constructor(required_action) {
        super(`local profile access denied: ${required_action}`);
        this.required_action = required_action;
    }
}
export class RevisionConflictError extends LocalDatabaseError {
    entity_id;
    expected_revision;
    actual_revision;
    constructor(entity_id, expected_revision, actual_revision) {
        super(`revision conflict for ${entity_id}: expected ${String(expected_revision)}, actual ${String(actual_revision)}`);
        this.entity_id = entity_id;
        this.expected_revision = expected_revision;
        this.actual_revision = actual_revision;
    }
}
export class DraftRevisionConflictError extends LocalDatabaseError {
    draft_key;
    expected_version;
    actual_version;
    constructor(draft_key, expected_version, actual_version) {
        super(`draft revision conflict for ${draft_key}: expected ${formatDraftVersion(expected_version)}, actual ${formatDraftVersion(actual_version)}`);
        this.draft_key = draft_key;
        this.expected_version = expected_version;
        this.actual_version = actual_version;
    }
}
export class DatasetEpochMismatchError extends LocalDatabaseError {
    expected_epoch;
    received_epoch;
    constructor(expected_epoch, received_epoch) {
        super(`dataset epoch mismatch: expected ${expected_epoch}, received ${received_epoch}`);
        this.expected_epoch = expected_epoch;
        this.received_epoch = received_epoch;
    }
}
export class FullResyncRequiredError extends LocalDatabaseError {
    constructor(message = 'device must complete a full resync before writing') {
        super(message);
    }
}
export class LocalReplacementCommittedError extends LocalDatabaseError {
    replacement_epoch;
    restore_checkpoint_id;
    committed = true;
    required_action = 'reopen_local_data_store';
    constructor(replacement_epoch, restore_checkpoint_id, options) {
        super(`local replacement committed at epoch ${replacement_epoch}; reopen the local data store`, options);
        this.replacement_epoch = replacement_epoch;
        this.restore_checkpoint_id = restore_checkpoint_id;
    }
}
export class TrashRestoreWindowExpiredError extends LocalDatabaseError {
    entity_id;
    constructor(entity_id) {
        super(`30-day restore window expired for ${entity_id}`);
        this.entity_id = entity_id;
    }
}
export class RepositoryClosedError extends LocalDatabaseError {
    constructor() {
        super('local data store is closed');
    }
}
export class UnsupportedStructuralMutationError extends LocalDatabaseError {
    constructor(message) {
        super(message);
    }
}
export class ProductionRollbackCompatibilityError extends LocalDatabaseError {
    code = 'production_rollback_route_default_requires_three_confirmations';
    constructor() {
        super('the compatibility reader cannot persist a route default with fewer than three confirmations');
    }
}
function formatDraftVersion(version) {
    return version === null ? 'null' : `${version.draft_id}@${String(version.autosave_revision)}`;
}
//# sourceMappingURL=errors.js.map